import script from "./SplittedCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./SplittedCollection.vue?vue&type=script&setup=true&lang=js"

import "./SplittedCollection.vue?vue&type=style&index=0&id=556f8a88&lang=scss&scoped=true"
script.__scopeId = "data-v-556f8a88"

export default script